module.exports = __webpack_public_path__ + "img/mosque_moon.63072dc8.svg";